import { Thumbnail } from 'mm-ui-components/src/base/partials/image/image.types';
import { SvgLink } from '../../navigations/navigation.utils';
import { AboutPageSedonaState } from './aboutPageSedona/aboutPageSedona.intialState';

export interface Author {
  authorInfo: {
    name: {
      type: string;
      value: string;
    };
    image?: {
      type: string;
      value: Thumbnail;
    };
    socialLinks?: {
      type: string;
      value: {alt: string; src: string; url: string}[] | [];
    };
    bio?: {
      type: string;
      value: string;
    };
    byline?: {
      type: string;
      value: string;
    };
    joinedDate?: {
      type: string;
      value: string;
    };
  };
  link: string;
  pagePath: string;
  name: string;
  pageID: string;
  userName: string;
}

export interface AuthorState {
  authorInfo: {
    name: string;
    image?: Thumbnail;
    socialLinks?: SvgLink[] | null;
    bio?: string;
    link?: string;
  };
}

export interface AboutPageAction {
  type: string;
}

type AboutPageState = AboutPageSedonaState;

export const aboutPageReducer = (
  state: AboutPageState = {} as AboutPageState,
  action: AboutPageAction,
) => {
  switch (action.type) {
    default:
      return state;
  }
};
